'use strict';
/* global _minimal_menu_enabled:false */

document.addEventListener('DOMContentLoaded', () => {
	const reviewsFlow = document.querySelector('.reviews_flow');
	if (!reviewsFlow) {
		return;
	}
	const reviewsFlowPositionTop = reviewsFlow.getBoundingClientRect().top + window.scrollY;
	let nextPage = reviewsFlow.getAttribute('data-next_page');
	let loadTrigger = reviewsFlowPositionTop + reviewsFlow.offsetHeight - reviewsFlow.offsetHeight * 0.2;
	let isFetching = false;

	window.addEventListener('scroll', function() {
		if (isFetching) {
			return false;
		}

		if (window.scrollY + window.innerHeight >= loadTrigger) {
			if (nextPage) {
				isFetching = true;
				fetcher(
					url('customer_reviews', { review_page: nextPage } ),
					{
						method: 'get',
					},
				).ready.then((response) => {
					if (response) {
						nextPage = response.next_page;
						Object.entries(response.reviews).forEach(([index, item]) => {
							let elem = `<div class='row margin_bottom20 review'>`;
							elem += `<div class='col-sm-2'>`;
							elem += `<div class='rev_widget_stars'>`;
							elem += `<img src='${h(url('/images/trustpilot/star_' + item.stars + '.svg'))}' alt='' width='80' height='15'>`;
							elem += `</div>`;
							elem += `<div class='rev_widget_name padding_bottom10 x-body-md'>${h(item.customer)}</div>`;
							elem += `</div>`;
							elem += `<div class='col-sm-10'>`;
							elem += `<div class='rev_widget_date pull-right x-body-sm'>${item.date}</div>`;
							elem += `<div class='rev_widget_title x-body-lg'>${h(item.title)}</div>`;
							elem += `<div class='rev_widget_text x-body-md'>${h(item.text)}</div>`;
							elem += `</div>`;
							elem += `</div>`;
							document.querySelector('.reviews_flow > .review:last-child').insertAdjacentHTML('afterend', elem);
						});
						loadTrigger = reviewsFlowPositionTop + reviewsFlow.offsetHeight - 500;
					}
				}).finally(()=>{
					isFetching = false;
				});
			}
		}
	});
});
